import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { DeadTotalCountSpinOrder as DeadTotalCountSpinOrderEnum } from "features/WorklistTools/shared/interfaces";
import { MethodSettingsProps } from "../shared";

export const DeadTotalCountSpinOrder = ({
  twelve24TCInternalState,
  handleMethodSettingsChanged,
}: MethodSettingsProps) => {
  const hasError =
    twelve24TCInternalState.methodSettings.deadTotalCountSpinOrder === null;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <FormControl variant="outlined" fullWidth error={hasError} size="small">
        <InputLabel id="dead-total-count-spin-order-label">
          Dead Total Count Spin Order
        </InputLabel>
        <Select
          fullWidth={true}
          labelId="dead-total-count-spin-order-label"
          id="dead-total-count-spin-order-select"
          value={
            twelve24TCInternalState.methodSettings.deadTotalCountSpinOrder ?? ""
          }
          label="Dead Total Count Spin Order"
          onChange={(e) => {
            const value = e.target.value as DeadTotalCountSpinOrderEnum | "";

            handleMethodSettingsChanged(
              "deadTotalCountSpinOrder",
              value === "" ? null : value,
            );
          }}
          disabled={
            twelve24TCInternalState.methodSettings.pelletResuspensionVol === 0
          }
        >
          <MenuItem value=""></MenuItem>
          <MenuItem value={DeadTotalCountSpinOrderEnum.CountBeforeSpin}>
            Count Before Spin
          </MenuItem>
          <MenuItem value={DeadTotalCountSpinOrderEnum.CountAfterSpin}>
            Count After Spin
          </MenuItem>
        </Select>
        <FormHelperText>{hasError ? "Required" : ""}</FormHelperText>
      </FormControl>
    </div>
  );
};
